jQuery(document).ready(function () {
  console.log('Running')
  
  // footer toggle
  try {
    if (jQuery(window).innerWidth() < 550) {
      const footerMenuHeading = jQuery('.oxitab-footer-section .menu-heading');
      if (footerMenuHeading.length) {
        footerMenuHeading.on('click', function () {
          jQuery(this).next('.oxitab-footer-section .menu-list-wrap').slideToggle();
        });
      }
    }
  } catch (error) {
    console.error('Error in footer toggle:', error);
  }

  // See why carousel section
  try {
    const seeWhyCarousel = jQuery('.see-why-carousel-section');
    if (seeWhyCarousel.length) {
      seeWhyCarousel.owlCarousel({
        loop: true,
        margin: 20,
        lazyLoad: true,
        center: true,
        nav: false,
        dots: true,
        slideBy: 1,
        items: 1,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1.2,
            dots: true,
          },
          550: {
            items: 1.2,
          },
          768: {
            items: 2,
          },
          1024: {
            items: 3,
          },
        },
      });
    }
  } catch (error) {
    console.error('Error in see-why-carousel:', error);
  }

  // Why choose carousel section
  try {
    const whyChooseCarousel = jQuery('.why-choose-carousel-section');
    if (whyChooseCarousel.length) {
      whyChooseCarousel.owlCarousel({
        loop: true,
        margin: 20,
        lazyLoad: true,
        center: true,
        nav: false,
        dots: true,
        slideBy: 1,
        items: 1,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1.2,
            dots: true,
          },
          550: {
            items: 1.5,
          },
          768: {
            items: 2,
          },
          1024: {
            items: 3.05,
          },
        },
      });
    }
  } catch (error) {
    console.error('Error in why-choose-carousel:', error);
  }

  // How to videos carousel
  try {
    const howToVideos = jQuery('#how-to-videos');
    if (howToVideos.length) {
      howToVideos.owlCarousel({
        loop: true,
        lazyLoad: true,
        center: false,
        dots: true,
        margin: 9,
        nav: true,
        navText: [
          `<img class="nav-btn prev-nav" src="https://cdn.shopify.com/s/files/1/0028/4331/2240/files/Vector_13.png?v=1728970661">`,
          `<img class="nav-btn next-nav" src="https://cdn.shopify.com/s/files/1/0028/4331/2240/files/Vector_14.png?v=1728970661">`,
        ],
        items: 1,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1.2,
            nav: false,
            center: true,
            dots: true,
          },
          550: {
            items: 2,
          },
          1024: {
            items: 2,
          },
          1440: {
            items: 4,
          },
        },
      });
    }
  } catch (error) {
    console.error('Error in how-to-videos carousel:', error);
  }

  //accordion script start
  try {
    var acc = document.getElementsByClassName('tabheading');

    if (acc.length) {
      Array.from(acc).forEach((tab) => {
        tab.addEventListener('click', function () {
          // Close all other panels
          Array.from(acc).forEach((otherTab) => {
            if (otherTab !== this && otherTab.nextElementSibling) {
              otherTab.classList.remove('current');
              otherTab.nextElementSibling.style.maxHeight = null;
            }
          });

          // Toggle the clicked panel
          this.classList.toggle('current');
          var panel = this.nextElementSibling;
          if (panel) {
            panel.style.maxHeight = panel.style.maxHeight ? null : panel.scrollHeight + 'px';
          }
        });
      });
    }
  } catch (error) {
    console.error('Error in accordion script:', error);
  }
  //accordion script ends

  // Video pause/play functionality
  try {
    const pauseImages = jQuery('.pause-image');
    if (pauseImages.length) {
      pauseImages.click(function () {
        const videoBox = jQuery(this).closest('.video-box');
        if (videoBox.length) {
          const mainVideo = videoBox.find('.main-video');
          if (mainVideo.length) {
            mainVideo.trigger('click');
          }
        }
      });
    }

    const mainVideos = jQuery('.main-video');
    if (mainVideos.length) {
      mainVideos.click(function () {
        if (this.paused) {
          this.play();
          const pauseImage = jQuery(this).closest('.video-box').find('.pause-image');
          if (pauseImage.length) {
            pauseImage.css('display', 'none');
          }
        } else {
          this.pause();
          const pauseImage = jQuery(this).closest('.video-box').find('.pause-image');
          if (pauseImage.length) {
            pauseImage.css('display', 'block');
          }
        }
      });
    }
  } catch (error) {
    console.error('Error in video functionality:', error);
  }

  // Handle toggle between Subscribe & Save and Buy Once
  try {
    const radioBoxes = document.querySelectorAll('.radio-box');
    if (radioBoxes.length) {
      radioBoxes.forEach(function (box) {
        box.addEventListener('click', function () {
          const subscribeBox = document.getElementById('subscribe-box');
          const buyOnceBox = document.getElementById('buy-once-box');
          const subscribePanel = document.getElementById('subscribe-options-panel');

          // Remove active class from both
          if (subscribeBox) subscribeBox.classList.remove('active');
          if (buyOnceBox) buyOnceBox.classList.remove('active');

          // Add active class to the selected box
          this.classList.add('active');

          // Show or hide the subscription panel based on the selection
          if (subscribePanel) {
            if (this.id === 'subscribe-box') {
              subscribePanel.style.display = 'block';
            } else {
              subscribePanel.style.display = 'none';
            }
          }
        });
      });
    }
  } catch (error) {
    console.error('Error in radio box toggle:', error);
  }

  // Add functionality for the dropdown if needed
  try {
    const deliveryFrequency = document.getElementById('delivery-frequency');
    if (deliveryFrequency) {
      deliveryFrequency.addEventListener('change', function () {
        console.log('Selected delivery frequency:', this.value);
      });
    }
  } catch (error) {
    console.error('Error in delivery frequency dropdown:', error);
  }

  // Subscription widget functionality START

  function waitForElementToLoad(selector, callback) {
    console.log('waitForElementToLoad - New: ', selector);
    const intervalId = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(intervalId);
        callback();
      }
    }, 500); // Check every half second
  }

  try {
    waitForElementToLoad('.rc-widget', function () {
      try {
        const variants = document.querySelectorAll('variant-selects fieldset label');
        const subsLabel = document.querySelector('.radio-box.subscribe-save');

        function updatePrice() {
          try {
            const rcRadioPrice = document.querySelector('.rc-radio__price');
            const priceItemRegular = document.querySelector('.price-item.price-item--regular');
            
            if (rcRadioPrice && priceItemRegular) {
              const subsPrice = rcRadioPrice.innerHTML + ' USD';
              priceItemRegular.innerHTML = subsPrice;
            }
          } catch (error) {
            console.error('Error in updatePrice:', error);
          }
        }

        // function handleVariantClick() {
        //   const checkedRadio = document.querySelector('input[name="purchaseOption"]:checked');
        //   if (checkedRadio) {
        //     if (checkedRadio.value === 'subscription') {
        //       console.log("Subscription checked");
        //       updatePrice();
        //     } else if (checkedRadio.value === 'onetime') {
        //       console.log("One-time checked");
        //       const oneTimePrice = document.querySelector('.onetime-radio .rc-radio__label').innerHTML;
        //       const finalOnePrice = oneTimePrice.split('purchase ')[1];
        //       document.querySelector('.price-item.price-item--regular').innerHTML = finalOnePrice;
        //     }
        //   }
        // }

        // Initial price update
        updatePrice();

        // variants.forEach(item => {
        //   item.addEventListener('click', handleVariantClick);
        // });

        if (subsLabel) {
          subsLabel.addEventListener('click', () => {
            try {
              const subscriptionRadio = document.querySelector('.subscription-radio');
              if (subscriptionRadio) {
                subscriptionRadio.click();
              }
              
              updatePrice();

              const selectElement = document.querySelector('#delivery-frequency');
              if (selectElement) {
                selectElement.selectedIndex = 0;
                const changeEvent = new Event('change', { bubbles: true });
                selectElement.dispatchEvent(changeEvent);
              }

              setTimeout(updatePrice, 500);
            } catch (error) {
              console.error('Error in subsLabel click handler:', error);
            }
          });
        }

        const buyOnceBox = document.querySelector('.radio-box.buy-once');
        if (buyOnceBox) {
          buyOnceBox.addEventListener('click', () => {
            try {
              const oneTimeRadioLabel = document.querySelector('.onetime-radio .rc-radio__label');
              const oneTimeRadio = document.querySelector('.onetime-radio');
              const priceItemRegular = document.querySelector('.price-item.price-item--regular');

              if (oneTimeRadioLabel && priceItemRegular) {
                const oneTimePrice = oneTimeRadioLabel.innerHTML;
                const finalOnePrice = oneTimePrice.split('purchase ')[1] + ' USD';
                console.log('Final one-time price:', finalOnePrice);

                if (oneTimeRadio) {
                  oneTimeRadio.click();
                }
                priceItemRegular.innerHTML = finalOnePrice;
              }
            } catch (error) {
              console.error('Error in buy-once click handler:', error);
            }
          });
        }

        const subscribeOptionsSelect = document.querySelector('#subscribe-options-panel select');
        if (subscribeOptionsSelect) {
          subscribeOptionsSelect.addEventListener('change', (event) => {
            try {
              const selectedOption = event.target.value;
              const subscriptionOptions = document.querySelectorAll('.rc-selling-plans-dropdown__select option');

              subscriptionOptions.forEach((option) => {
                if (option.innerHTML === selectedOption) {
                  option.selected = true;
                  const changeEvent = new Event('change', { bubbles: true });
                  if (option.parentNode) {
                    option.parentNode.dispatchEvent(changeEvent);
                  }
                }
              });

              setTimeout(updatePrice, 500);
            } catch (error) {
              console.error('Error in subscribe-options change handler:', error);
            }
          });
        }
      } catch (error) {
        console.error('Error in rc-widget callback:', error);
      }
    });
  } catch (error) {
    console.error('Error in subscription widget functionality:', error);
  }

  // Subscription widget functionality END

  // trigger carousel image on arrow click script start
  try {
    const leftArrow = document.querySelector('.custom-product-arrow-wrapper #left-arrow');
    const rightArrow = document.querySelector('.custom-product-arrow-wrapper #right-arrow');
    const sliders = document.querySelectorAll('slider-component ul.slider');
    
    if (leftArrow && rightArrow && sliders.length > 1) {
      const bottomSlider = sliders[1];

      function updateArrowState() {
        try {
          const currentButton = bottomSlider.querySelector('button[aria-current="true"]');
          
          if (!currentButton) return;

          // Disable left arrow if it's the first button
          const firstButton = bottomSlider.querySelector('li:first-child button');
          if (currentButton === firstButton) {
            leftArrow.classList.add('disabled');
          } else {
            leftArrow.classList.remove('disabled');
          }

          // Disable right arrow if it's the last button
          const lastButton = bottomSlider.querySelector('li:last-child button');
          if (currentButton === lastButton) {
            rightArrow.classList.add('disabled');
          } else {
            rightArrow.classList.remove('disabled');
          }
        } catch (error) {
          console.error('Error in updateArrowState:', error);
        }
      }

      rightArrow.addEventListener('click', function () {
        try {

          const currentButton = bottomSlider.querySelector('button[aria-current="true"]');
          if (currentButton) {
            const nextButton = currentButton.closest('li')?.nextElementSibling?.querySelector('button');
            if (nextButton) {
              nextButton.click();
              updateArrowState(); // Update arrow states after clicking
            }
          }
        } catch (error) {
          console.error('Error in rightArrow click:', error);
        }
      });

      leftArrow.addEventListener('click', function () {
        try {
          const currentButton = bottomSlider.querySelector('button[aria-current="true"]');
          if (currentButton) {
            const prevButton = currentButton.closest('li')?.previousElementSibling?.querySelector('button');
            if (prevButton) {
              prevButton.click();
              updateArrowState(); // Update arrow states after clicking
            }
          }
        } catch (error) {
          console.error('Error in leftArrow click:', error);
        }
      });

      // Initial state check
      updateArrowState();
    }
  } catch (error) {
    console.error('Error in carousel arrow functionality:', error);
  }
  // trigger carousel image on arrow click script end
});